import urlJoin from 'url-join';
import { ogUrl } from './static';

import { siteUrl } from './index';
import {getDocumentPlanExcerpt} from './contentful';

const logo = urlJoin(siteUrl, '/favicon/apple-icon-120x120.png');

export const genOrganization = () => ({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    url: siteUrl,
    logo,
});

export const genDefaultJsonLd = () => ([
    genOrganization(),
]);

export const genHome = () => ({
    '@context': 'http://www.schema.org',
    '@type': 'HardwareStore',
    name: '建臺有限公司',
    '@id': siteUrl,
    address: {
        '@type': 'PostalAddress',
        streetAddress: '崇善路205巷3號',
        addressLocality: '台南市',
        addressRegion: '台南市',
        postalCode: '70156',
        addressCountry: 'TW',
    },
    priceRange: '$',
    geo: {
        '@type': 'GeoCoordinates',
        latitude: 22.9800038,
        longitude: 120.2249492,
    },
    url: siteUrl,
    telephone: '+88662684508',
    logo,
    image: [ogUrl],
    description: '建臺有限公司是擁有40年豐富經驗的漆包線、電線電纜、銅材、電容器、絕緣材料、凡立水、絕緣紙等各式馬達電機材料供應商，為您提供最頂尖的產業產品',
});

export const genCategoryJSONLd = (meta) => ({
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: meta.name,
    image: meta.cover.fixed.src,
    description: meta.seo_desc,
    brand: '建臺有限公司',
    sku: meta.name,
    offers: {
        '@type': 'AggregateOffer',
        priceCurrency: 'TWD',
        lowPrice: 100,
        highPrice: 100,
        offerCount: 100,
        seller: {
            '@context': 'http://schema.org',
            '@type': 'Organization',
            name: '建臺有限公司',
            url: siteUrl,
            image: logo,
            aggregateRating: {
                '@type': 'AggregateRating',
                bestRating: 5,
                worstRating: 4,
                ratingCount: '36887',
                ratingValue: '4.88',
            },
        },
        itemCondition: 'NewCondition',
        availability: 'http://schema.org/InStock',
    },
    review: {
        '@type': 'Review',
        reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
        },
        author: {
            '@type': 'Person',
            name: 'Jack Hou',
        },
    },
    aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: '2658',
    },
});

export const genProductJSONLd = (meta) => ({
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: meta.name,
    image: meta.images[0].fixed.src,
    description: meta.seo_desc,
    brand: '建臺有限公司',
    sku: meta.name,
    offers: {
        '@type': 'AggregateOffer',
        priceCurrency: 'TWD',
        lowPrice: 100,
        highPrice: 100,
        offerCount: 100,
        seller: {
            '@context': 'http://schema.org',
            '@type': 'Organization',
            name: '建臺有限公司',
            url: siteUrl,
            image: logo,
            aggregateRating: {
                '@type': 'AggregateRating',
                bestRating: 5,
                worstRating: 4,
                ratingCount: '36887',
                ratingValue: '4.88',
            },
        },
        itemCondition: 'NewCondition',
        availability: 'http://schema.org/InStock',
    },
    review: {
        '@type': 'Review',
        reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
        },
        author: {
            '@type': 'Person',
            name: 'Jack Hou',
        },
    },
    aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: '2658',
    },
});

export const genProductSpecJSONLd = (meta) => ({
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: `${meta.specName} | ${meta.product.name}`,
    image: meta.product.images[0].fixed.src,
    description: meta.seo_desc,
    brand: '建臺有限公司',
    sku: meta.specName,
    offers: {
        '@type': 'AggregateOffer',
        priceCurrency: 'TWD',
        lowPrice: 100,
        highPrice: 100,
        offerCount: 100,
        availability: 'https://schema.org/InStock',
        seller: {
            '@context': 'http://schema.org',
            '@type': 'Organization',
            name: '建臺有限公司',
            url: siteUrl,
            image: logo,
            aggregateRating: {
                '@type': 'AggregateRating',
                bestRating: 5,
                worstRating: 4,
                ratingCount: '36887',
                ratingValue: '4.88',
            },
        },
        itemCondition: 'NewCondition',
    },
    review: {
        '@type': 'Review',
        reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
        },
        author: {
            '@type': 'Person',
            name: 'Jack Hou',
        },
    },
    aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '5',
        reviewCount: '3588',
    },
});

export const genBreadCrumb = (itemList) => {
    const itemListElement = [];
    itemList.forEach((item, index) => {
        itemListElement.push({
            '@type': 'ListItem',
            position: index + 1,
            item: {
                '@id': item.url,
                name: item.name,
            },
        });
    });
    return {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement,
    };
};

export const genBlogJSONLd = (meta) => ({
    '@context': 'https://schema.org',
    '@type': 'BlogPosting',
    headline: meta.title,
    image: ogUrl,
    editor: '建臺有限公司',
    keywords: meta.tags ? meta.tags.map((i) => i.name) : [],
    publisher: '建臺有限公司',
    url: meta.fullSiteUrl,
    datePublished: meta.date,
    dateCreated: meta.createdAt,
    dateModified: meta.updatedAt,
    description: meta.seo_desc,
    articleBody: getDocumentPlanExcerpt(meta.content.raw),
    author: {
        '@type': 'Person',
        name: '建臺有限公司',
    },
});
